module.exports = __webpack_public_path__ + "img/thankbg.d1a426ca.png";